import { Timestamp } from 'firebase/firestore';

export const formatDate = (date) => {
  if (!date) return 'N/A';
  
  try {
    let dateObj;
    
    // Handle Firestore Timestamp
    if (date instanceof Timestamp) {
      dateObj = date.toDate();
    }
    // Handle date.toDate() method (another Firestore format)
    else if (date?.toDate && typeof date.toDate === 'function') {
      dateObj = date.toDate();
    }
    // Handle JavaScript Date object
    else if (date instanceof Date) {
      dateObj = date;
    }
    // Handle date-only string (YYYY-MM-DD) as local date to avoid timezone off-by-one
    else if (typeof date === 'string') {
      const trimmed = date.trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        const [y, m, d] = trimmed.split('-').map(Number);
        dateObj = new Date(y, m - 1, d);
      } else {
        dateObj = new Date(date);
      }
    }
    // Handle seconds timestamp
    else if (date.seconds) {
      dateObj = new Date(date.seconds * 1000);
    }
    else {
      return 'N/A';
    }

    // Return short format: "1/27/25"
    return dateObj.toLocaleDateString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: '2-digit'
    });

  } catch (error) {
    console.error('Error formatting date:', error, date);
    return 'N/A';
  }
}; 